module.exports = __webpack_public_path__ + "img/logo.394064b8.png";